import { render } from "./beneficiary_analytics_index_by_process.vue?vue&type=template&id=2866c654&dir=rtl"
import script from "./beneficiary_analytics_index_by_process.vue?vue&type=script&lang=js"
export * from "./beneficiary_analytics_index_by_process.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__